<template>
  <div class="findlaw_hfyxls">
    <!-- <div class="hfyxls_top">
      <div><hc :tagify="zylist"  /></div>
    </div> -->

    <div class="hfyxls_adv between">
      <div
        class="hfyxls_item"
        v-for="(item, index) in 4"
        :key="index"
        :class="{ hfyxls_item2: index % 2 == 0 }"
      >
        <div class="ti">蒋俊律师</div>
        <div class="de">刑事辩护、交通事故、交通事故</div>
        <div class="pho flex_start">
          <svg-icon icon-class="dianhua" class="svgimg" />1776588112
        </div>
        <div class="online text_hover_shou">在线咨询</div>
        <div class="figure">
          <img src="../../../assets/question/figure.png" />
        </div>
      </div>
    </div>
    <div class="ytls mt50 text_center">
      <sec-title Text="合肥优选律师" desc-text="好品质 值得信赖"></sec-title>

      <div class="ytls_sw">
        <el-carousel
          height="535px"
          indicator-position="none"
          ref="ytls_sw"
          arrow="never"
          @change="ytls_c"
          @mouseenter.native="autoplayHandler"
        >
          <el-carousel-item v-for="item in 4" :key="item">
            <div class="ytls_itm flex_start">
              <div class="itban">
                <img src="../../../assets/findlawyers/switem.png" />
              </div>
              <div class="ittext">
                <div class="t4">XX团队律师 <span>主任律师</span></div>
                <div class="d4">
                  近期帮助 <span>952</span> 人 | 响应时间 <span>1</span> 天内
                </div>
                <div class="e4">
                  专注疑难复杂案件处理，团队大部分成员为离职法官、检察官，
                  具备较高的法律素养
                </div>
                <div class="t5">
                  <svg-icon icon-class="dianhua" class="svgimg" />
                  1776588112
                </div>
              </div>
              <div class="btext">{{ "0" + item }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="operation flex_end">
          <div class="prev center" @click="prev">
            <svg-icon icon-class="jt_right" class="flip180"></svg-icon>
          </div>
          <div class="page between">
            <span
              class="text_hover_shou"
              v-for="item in 4"
              :key="item"
              @click="ytlitem_click(item)"
              :class="{ actvspan: item == active }"
              >{{ item }}</span
            >
          </div>
          <div class="next center" @click="next">
            <svg-icon icon-class="jt_right"></svg-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hc from "../components/heyxlsCollapse";
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    hc,
    secTitle,
  },
  data: () => ({
    active: 1,
    zylist: [],
  }),
  created() {
    this.getzhuanye();
  },
  methods: {
    autoplayHandler() {
      this.$refs.ytls_sw.handleMouseEnter = () => {};
    },
    ytlitem_click(e) {
      this.$refs.ytls_sw.setActiveItem(e - 1);
    },
    ytls_c(item) {
      this.active = item + 1;
    },
    prev() {
      this.$refs.ytls_sw.prev();
    },
    next() {
      this.$refs.ytls_sw.next();
    },
    getzhuanye() {
      this.$http.fdlaw
        .getIndustryIfy()
        .then((res) => {
          console.log("专业列表接口获取", res);
          this.zylist = res.data;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
};
</script>

<style lang="scss" scope>
.findlaw_hfyxls {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0px;
  background-color: #fff;
  .hfyxls_top {
    padding: 23px 30px 13px;
    border: 1px solid #eeee;
  }
  .hfyxls_adv {
    margin-top: 50px;
    .hfyxls_item {
      width: 280px;
      height: 168px;
      font-size: 12px;
      padding: 25px 30px 0;
      border-radius: 10px;
      position: relative;
      background-image: url("../../../assets/question/quest_ad_bg0.png");
      .ti {
        font-weight: 600;
        font-size: 18px;
      }
      .de {
        margin: 10px 0;
      }
      .pho {
        .svgimg {
          color: #ff841e;
        }
      }
      .online {
        font-size: 14px;
        display: inline-block;
        padding: 2px 8px;
        color: #ff3000;
        margin-top: 8px;
        border: 1px solid #ff3000;
        border-radius: 20px;
      }
      .figure {
        position: absolute;
        bottom: 0;
        right: 5px;
        img {
          width: 110px;
          height: 150px;
        }
      }
    }
    .hfyxls_item2 {
      background-image: url("../../../assets/question/quest_ad_bg1.png");
      .pho .svgimg {
        color: #1375ff;
      }
    }
  }
  .ytls {
    .ytls_sw {
      position: relative;
      .ytls_itm {
        position: relative;
        height: 535px;
        .itban {
          width: 648px;
          height: 395px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .ittext {
          width: 510px;
          height: 300px;
          padding: 37px 27px;
          margin-left: -65px;
          background-color: #fff;
          color: #333333;
          text-align: left;
          box-shadow: 0px 17px 21px 0px rgba(0, 0, 0, 0.08);
          .t4 {
            font-size: 20px;
            line-height: 20px;
            position: relative;
            &::after {
              position: absolute;
              content: "";
              width: 37px;
              height: 2px;
              bottom: -24px;
              left: 0;
              background-color: #333333;
            }
            span {
              font-size: 16px;
              color: #666666;
              margin-left: 13px;
            }
          }
          .d4 {
            margin-top: 44px;
            font-size: 14px;
            color: #999999;
            line-height: 24px;
            span {
              color: #cb0d0f;
            }
          }
          .e4 {
            font-size: 14px;
            color: #666666;
            line-height: 26px;
            margin-top: 8px;
          }
          .t5 {
            margin-top: 15px;
            .svgimg {
              color: #1375ff;
            }
          }
        }
        .btext {
          font-size: 270px;
          position: absolute;
          top: -60px;
          right: -15px;
          z-index: -1;
          color: rgba(194, 219, 255, 0.1);
        }
      }
      .operation {
        min-width: 200px;
        .prev,
        .next {
          width: 32px;
          height: 32px;
          border: 1px solid #cccccc;
          color: #cccccc;
          border-radius: 50%;
          &:hover {
            background-color: #0465ea;
            color: #fff;
          }
        }
        .page {
          margin: 0 20px 0 34px;
          span {
            font-size: 14px;
            color: #ccc;
            margin-right: 15px;
          }
          .actvspan {
            color: #0465ea;
          }
        }
      }
    }
  }
}
</style>